import React from 'react';
import PropTypes from 'prop-types';
import MessageContent from 'components/messages/MessageContent';
import Message from 'components/Message';
import MessageButton from 'components/messages/MessageButton';

const FailedLoginMessage = ({ onNewPasswordClick, onNewLoginClick, onDismiss }) => (
  <Message
    type="error"
    onDismiss={onDismiss}
    message={(
      <MessageContent>
        Sorry, the login credentials were not recognised. You can request a&nbsp;
        <MessageButton onClick={onNewPasswordClick}>new password</MessageButton>
        &nbsp;or&nbsp;
        <MessageButton onClick={onNewLoginClick}>
          log in with a different email address
        </MessageButton>
      </MessageContent>
    )}
  />
);

FailedLoginMessage.displayName = 'FailedLoginMessage';

FailedLoginMessage.propTypes = {
  onNewPasswordClick: PropTypes.func.isRequired,
  onNewLoginClick: PropTypes.func.isRequired,
  onDismiss: Message.propTypes.onDismiss.isRequired,
};

export default FailedLoginMessage;
